import { ADDTOCART, DECREMENT } from "./actionsType";

export const addToCartActionCreator = (payload) => {
    return { type: ADDTOCART, payload }
};
export const decrementActionCreator = (payload) => {
    return { type: DECREMENT, payload }
};